// extracted by mini-css-extract-plugin
export default {"wrapper":"confirmModal_wrapper__sN7Qn","inside":"confirmModal_inside__3t0Sc"};